var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.035 3.7819L2.93372 31.935C2.0577 33.4667 3.16244 35.3741 4.92559 35.3741H37.0744C38.8361 35.3741 39.941 33.4695 39.0679 31.9378L23.0204 3.78476C22.1403 2.24083 19.9173 2.23923 19.035 3.7819ZM0.657308 30.6303L16.7586 2.47724C18.6492 -0.82848 23.4128 -0.825056 25.2986 2.48338L41.3462 30.6364C43.2172 33.9187 40.8495 38 37.0744 38H4.92559C1.14741 38 -1.21989 33.9126 0.657308 30.6303Z",
    fill: "#FFC000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7227 12.5623H22.3458V24.8709H19.7227V12.5623Z",
    fill: "#FFC000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8372 28.9737C22.8372 29.9708 22.0298 30.779 21.0338 30.779C20.0379 30.779 19.2305 29.9708 19.2305 28.9737C19.2305 27.9767 20.0379 27.1685 21.0338 27.1685C22.0298 27.1685 22.8372 27.9767 22.8372 28.9737Z",
    fill: "#FFC000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.72d34d1d6fad0d5d4e5c3ea6bff06245.svg";
export { ForwardRef as ReactComponent };